import { createFileRoute } from "@tanstack/react-router";
import { OwnStbVsSmartTvPage } from "@/components/guides/OwnStbVsSmartTvPage";
import { ownStbVsSmartTvSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/own-stb-vs-smart-tv")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => ownStbVsSmartTvSeo(loaderData?.href ?? "/guides/own-stb-vs-smart-tv"),
  component: OwnStbVsSmartTvPage,
});
